import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import { useAppAction, useAppSelector } from "../hooks/redux.js";
import { getCurrentSpec } from "../utils/selectors.js";
import { initStyle } from "../reducers/historyEnhancer.js";
import { FormattedMessage } from "react-intl";
import { useCaptureEvent } from "./StyleEditorContext.js";
import { Event } from "../constants/events.js";
export const SaveModal = ({ opened, onClose, onSave, onContinue }) => {
    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState(null);
    const current = useAppSelector(getCurrentSpec);
    const setInitState = useAppAction(initStyle);
    const captureEvent = useCaptureEvent();
    const handleSave = useCallback(() => {
        if (!onSave)
            return;
        setIsPending(true);
        void onSave(current)
            .then((style) => {
            setInitState(style);
            captureEvent(Event.SaveMapSuccess);
            onClose();
            onContinue();
        })
            .catch((saveError) => {
            setError(saveError);
        })
            .finally(() => {
            setIsPending(false);
        });
    }, [current, setInitState, onClose, onSave, onContinue]);
    return (_jsx(Modal, { opened: opened, onClose: onClose, title: (_jsx(FormattedMessage, { id: "title.saveMapBeforePublish", defaultMessage: "Save map before publish" })), size: "md", children: _jsxs(Stack, { children: [error && (_jsx(Alert, { color: "red", icon: _jsx(IconExclamationCircle, {}), children: error.message })), _jsx(Text, { children: _jsx(FormattedMessage, { id: "text.saveBeforePublish", defaultMessage: "To publish your map, changes has to be saved first." }) }), _jsxs(Group, { gap: "md", justify: "flex-end", mt: "md", children: [_jsx(Button, { variant: "default", onClick: onClose, disabled: isPending, children: _jsx(FormattedMessage, { id: "button.cancel", defaultMessage: "Cancel" }) }), _jsx(Button, { variant: "tertiary", type: "submit", onClick: handleSave, loading: isPending, children: _jsx(FormattedMessage, { id: "button.saveAndContinue", defaultMessage: "Save and continue" }) })] })] }) }));
};
